import { TBuildersInfo } from '../../types/redux/state';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EBuildersInfoActionTypes {
  Request = 'BUILDERS_INFO/REQUEST',
  Success = 'BUILDERS_INFO/SUCCESS',
  Failure = 'BUILDERS_INFO/FAILURE',
}

export const buildersInfoSuccess = actionGenerator<EBuildersInfoActionTypes.Success, TBuildersInfo>(
  EBuildersInfoActionTypes.Success,
);

export const buildersInfoRequest = actionGenerator<EBuildersInfoActionTypes.Request>(EBuildersInfoActionTypes.Request);

export const buildersInfoFailure = actionGenerator<EBuildersInfoActionTypes.Failure>(EBuildersInfoActionTypes.Failure);

export type TBuildersInfoActions =
  | ReturnType<typeof buildersInfoRequest>
  | ReturnType<typeof buildersInfoSuccess>
  | ReturnType<typeof buildersInfoFailure>;
